import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { MissionHero } from "@modules/study/mission";

const VissionMission = () => {
  return (
    <LayoutMain
      title="Vision Mission"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/vision-mission`}
    >
      <MissionHero />
    </LayoutMain>
  );
};

export default VissionMission;
